import React from 'react'
import { Tag, Spin, Empty, Button, Tooltip } from 'antd'
import { UserOutlined, ReloadOutlined } from '@ant-design/icons'
import { useI18n } from '@/shared/i18n'
import { useCustomerContext, parseContextText } from './customerContextApi'

interface Props {
  platform: string
  platformUserId: string
}

const CustomerContextPanel: React.FC<Props> = ({ platform, platformUserId }) => {
  const { t } = useI18n('modules')
  const { data, isLoading, isError, refetch } = useCustomerContext(
    platform,
    platformUserId,
    true,
  )

  const fields = data ? parseContextText(data.context_text) : []

  return (
    <div className="customer-context-panel">
      <div className="context-panel-header">
        <span>
          <UserOutlined style={{ marginRight: 6 }} />
          {t('chatbot.context.title')}
        </span>
        <Tooltip title={t('chatbot.context.refresh')}>
          <Button
            type="text"
            size="small"
            icon={<ReloadOutlined spin={isLoading} />}
            onClick={() => refetch()}
          />
        </Tooltip>
      </div>
      <div className="context-panel-body">
        {isLoading && !data ? (
          <div className="context-loading">
            <Spin size="small" />
          </div>
        ) : isError ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={t('chatbot.context.error')}
          />
        ) : fields.length === 0 ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={t('chatbot.context.empty')}
          />
        ) : (
          <div className="context-fields">
            {fields.map((field, idx) => (
              <div key={idx} className="context-field">
                {field.label ? (
                  <>
                    <span className="context-field-label">{field.label}</span>
                    <span className="context-field-value">{field.value}</span>
                  </>
                ) : (
                  <Tag color="blue">{field.value}</Tag>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default CustomerContextPanel
